import { calculateDamageMultiplier } from '../damage.js';

/**
 * Apply armor/MR (or none for true) using the shared damage.js formula.
 * @returns {number} mitigated amount before shields / rounding
 */
export function resolveMitigatedDamage(amount, damageType, armor = 0, mr = 0) {
  if (!(amount > 0)) return 0;
  if (damageType === 'true') return amount;
  if (damageType === 'physical') {
    return amount * calculateDamageMultiplier(armor || 0);
  }
  if (damageType === 'magic') {
    return amount * calculateDamageMultiplier(mr || 0);
  }
  return amount;
}
